import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { LoadingSpinner } from '@employ-engage/common-components';

export const InvitePage = () => {
  const { inviteId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (inviteId) {
      // getDoc(getJoinCompanyInvitationDocRef(company.id, inviteId))
      //   .then((doc) => {
      //     if (doc.exists()) {
      //       navigate(`/${currentCompany.friendlyCompanyId}/invite-acceptance/${inviteId}`);
      //     } else {
      //       navigate(`/${currentCompany.friendlyCompanyId}/invite-not-found`);
      //     }
      //   })
      //   .catch(() => {
      //     navigate(`/${currentCompany.friendlyCompanyId}/invite-not-found`);
      //   });
    }
  }, [inviteId, navigate]);

  return <LoadingSpinner spinnerId="invite-page-loading" />;
};

export default InvitePage;
